import React from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';
import './ProgressBar.css';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
type progressBarProps = {
  progressBarPercentage: number;
  isLabelNeeded: boolean;
  className: string;
  variant: string;
  tooltipNeeded?: boolean;
  percentageNeededOnRight?: boolean;
};
const ProgressBarComponent: React.FC<progressBarProps> = ({
  progressBarPercentage,
  isLabelNeeded,
  className,
  variant,
  tooltipNeeded,
  percentageNeededOnRight,
}) => {
  const renderProgressBar = () => (
    <div className={`progress_bar_main ${className}`}>
      <div className="progress_bar_inside_main">
        <ProgressBar
          className={`progress_bar_for_styling ${variant}`}
          now={progressBarPercentage}
          label={isLabelNeeded ? `${progressBarPercentage}%` : null}
        />
      </div>
      {percentageNeededOnRight ? (
        <span className="percentageNeededOnRight">
          {progressBarPercentage}%
        </span>
      ) : null}
    </div>
  );
  const tooltip = (
    <Tooltip className={`tooltip_for_styling-${variant}`}>
      {`${progressBarPercentage}%`}
    </Tooltip>
  );
  return tooltipNeeded ? (
    <OverlayTrigger placement="top" overlay={tooltip}>
      {renderProgressBar()}
    </OverlayTrigger>
  ) : (
    renderProgressBar()
  );
};
export default ProgressBarComponent;
